module.exports = __webpack_public_path__ + "img/13.4e706b7d.jpg";